import { Link } from 'react-router-dom';
import { EditFilled } from '@ant-design/icons';
import '@/assets/style/companyList.scss';

/**
 * EditButton component that renders an edit button with a link.
 *
 * @component
 * @example
 * const path = "/edit/1";
 * return (
 *   <EditButton path={path} />
 * )
 *
 * @param {Object} props - Component props.
 * @param {string} props.path - The path to navigate to when the button is clicked.
 * @returns {React.Element} The rendered component.
 */
const EditButton = ({ path }) => {
  return (
    <div className="ant-button-edit">
      <Link to={path} size="medium" className="edit">
        <EditFilled />
      </Link>
    </div>
  );
};

export default EditButton;
